import { ViewType } from 'react-big-schedule';
import { STRING_VIEW_TYPE } from './constant';

const invertMap = map => Object.fromEntries(Object.entries(map).map(([key, value]) => [value, Number(key)]));

// Map From number view type to string view type
const STRING_VIEW_MAP = {
  [ViewType.Day]: STRING_VIEW_TYPE.DAY,
  [ViewType.Week]: STRING_VIEW_TYPE.WEEK,
  [ViewType.Month]: STRING_VIEW_TYPE.MONTH,
  [ViewType.Quarter]: STRING_VIEW_TYPE.QUARTER,
  [ViewType.Year]: STRING_VIEW_TYPE.YEAR,
};

// Map From string view type to number view type
const NUMBER_VIEW_MAP = invertMap(STRING_VIEW_MAP);

export function stringToViewType(stringView) {
  return NUMBER_VIEW_MAP[stringView] === undefined ? ViewType.Week : NUMBER_VIEW_MAP[stringView];
}

export function viewTypeToString(numberView) {
  return STRING_VIEW_MAP[numberView] || STRING_VIEW_TYPE.WEEK;
}
